/**
 * @voltxampere/ui — DS1307 I2C RTC (Sprint 45-5, placeholder)
 *
 * PLACEHOLDER. I2C bus simulation + RTC time tick Sprint 47+
 * engine extension #4 ile aktif. Şu anki davranış `digital-gate`
 * placeholder.
 *
 * Reference: Maxim / Analog Devices DS1307 — DIP-8 / SOIC-8.
 * I2C Real-Time Clock, V_CC 4.5-5.5 V (battery backup CR2032),
 * 56-byte SRAM scratchpad, 32.768 kHz xtal external. Zaman damgası,
 * data logger, alarm clock, timer.
 *
 *   Default mapping → digital-gate schemaType:
 *     gateFunction = "NOT"
 *     vHigh = 5
 *     propagationDelay = 1e-6  (1 µs I2C response)
 *
 * Engine zero-diff invariant honored — canonical `digital-gate`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const memoryDs1307 = {
    id: "ds1307",
    nameTr: "DS1307 (I2C RTC, DIP-8, placeholder)",
    nameEn: "DS1307 (I2C RTC, DIP-8, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "DS1307",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 1e-6,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=memory-ds1307.js.map